import React, { Component } from "react";
import { observer } from "mobx-react";
import { fn_devliery_connect_add_pop } from "function/FnBodyDelivery"
import { pay_free_yntype } from "http/SettingConn"

@observer
class SettingDefaultDeliveryConnectView extends Component {
    componentDidMount() {
        const { rootStore } = this.props;
    }

    render() {
        const { rootStore } = this.props;
        let dlvList = rootStore.deliveryStore.getDeliveryConnectList;

        return (
            <>
                <div className="section_content">
                    <h3>배달대행사 연동하기</h3>
                    <div className="scroll">
                        <div className="inner">
                            <div className="wrap_delivery connect">
                                {/* <h4>배달대행사 연동하기</h4> */}
                                {/* <div className="info"><span className="ico"></span><strong>배달대행사 프로그램 설치 후</strong>에 연동을 진행해주세요.</div> */}
                                <div className="box_list">
                                    <p className="txt">
                                        <strong>배달대행사 프로그램 설치 후</strong>에 연동을 진행해주세요.
                                    </p>
                                </div>
                                <ul>
                                    {
                                        (Array.isArray(dlvList) && dlvList.length > 0)
                                            ?
                                            dlvList.map((item, idx) =>
                                                (item.mappingYn == "N") ?
                                                    <li key={idx}>
                                                        <div className="item">
                                                            <p className="company">{item.deliveryServiceName}</p>
                                                            <p className="platform">{item.parentDeliveryServiceName}</p>
                                                        </div>
                                                        <div className="btn" onClick={event => {
                                                            event.preventDefault();
                                                            fn_devliery_connect_add_pop(rootStore, item)
                                                        }}>추가</div>
                                                    </li>
                                                    : ""
                                            )
                                            : ""
                                    }

                                </ul>
                            </div>
                        </div>
                        <div className="close">
                            <button type="button" onClick={event => { event.preventDefault(); rootStore.layerStore.setLayerDlvConnectView(false); pay_free_yntype(rootStore) }} ><span>페이지 닫기</span></button>
                        </div>
                    </div>
                </div >

            </>
        )
    }
}

export default SettingDefaultDeliveryConnectView;